// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Based on HTML rendering suggestions and the differences across UA sheets:
 * https://html.spec.whatwg.org/multipage/rendering.html
 *
 * Selectors sorted as they appear in the HTML Standard for better compression.
 */

html {
  line-height: 1;
}

/* Only for Safari: button, select, input, textarea */
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
hr,
pre,
blockquote,
ol,
ul,
menu,
dl,
dd,
figure,
input,
button,
select,
textarea,
fieldset {
  margin: 0;
}

hr,
iframe,
input,
button,
select,
textarea,
fieldset {
  border: 0;
}

ol,
ul,
menu,
td,
th,
input,
button,
select,
textarea,
fieldset,
legend {
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
address,
th {
  font: inherit; /* font-size, font-weight, font-style */
}

ol,
ul,
menu {
  list-style: none; /* list-style-type */
}

a {
  color: inherit;
  text-decoration: inherit;
}

table {
  border-spacing: 0;
}

th {
  text-align: inherit;
}

input,
button,
select,
textarea {
  background: none;

  /* https://adrianroselli.com/2019/09/under-engineered-text-boxen.html */
  font: inherit;
  letter-spacing: inherit;
  word-spacing: inherit;

  color: inherit;
}

/* Only for Firefox */
input::placeholder,
textarea::placeholder {
  color: gray;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./node_modules/css-homogenizer/reset.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;;;;;;;;;;;;;;;;;;;;;;EAsBE,SAAS;AACX;;AAEA;;;;;;;EAOE,SAAS;AACX;;AAEA;;;;;;;;;;;EAWE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,aAAa,EAAE,uCAAuC;AACxD;;AAEA;;;EAGE,gBAAgB,EAAE,oBAAoB;AACxC;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;;EAEhB,uEAAuE;EACvE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;;EAErB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAEE,WAAW;EACX,UAAU;AACZ","sourcesContent":["/**\n * Based on HTML rendering suggestions and the differences across UA sheets:\n * https://html.spec.whatwg.org/multipage/rendering.html\n *\n * Selectors sorted as they appear in the HTML Standard for better compression.\n */\n\nhtml {\n  line-height: 1;\n}\n\n/* Only for Safari: button, select, input, textarea */\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nhr,\npre,\nblockquote,\nol,\nul,\nmenu,\ndl,\ndd,\nfigure,\ninput,\nbutton,\nselect,\ntextarea,\nfieldset {\n  margin: 0;\n}\n\nhr,\niframe,\ninput,\nbutton,\nselect,\ntextarea,\nfieldset {\n  border: 0;\n}\n\nol,\nul,\nmenu,\ntd,\nth,\ninput,\nbutton,\nselect,\ntextarea,\nfieldset,\nlegend {\n  padding: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\naddress,\nth {\n  font: inherit; /* font-size, font-weight, font-style */\n}\n\nol,\nul,\nmenu {\n  list-style: none; /* list-style-type */\n}\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\ntable {\n  border-spacing: 0;\n}\n\nth {\n  text-align: inherit;\n}\n\ninput,\nbutton,\nselect,\ntextarea {\n  background: none;\n\n  /* https://adrianroselli.com/2019/09/under-engineered-text-boxen.html */\n  font: inherit;\n  letter-spacing: inherit;\n  word-spacing: inherit;\n\n  color: inherit;\n}\n\n/* Only for Firefox */\ninput::placeholder,\ntextarea::placeholder {\n  color: gray;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
